import "core-js/modules/es.array.concat.js";
export var exampleData = function exampleData(_this) {
  return [
  // 1
  [{
    title: "(".concat(_this.$t('b195d134'), ")").concat(_this.$t('i18n.afdfff977ffb44d482f0ce31ea2e29f5')),
    label: _this.$t('i18n.b7332990207a4a289a6be4c00013c631'),
    value: '12,000.00/30*19 = 7,600.00 THB',
    date: [{
      date: '2022.03',
      day: 31,
      hire: 28,
      leave: '',
      before_min: '',
      before_max: '',
      data_min: 28,
      data_max: 31
    }, {
      date: '2022.04',
      day: 30,
      hire: '',
      leave: '',
      before_min: '',
      before_max: '',
      data_min: 1,
      data_max: 15
    }]
  }, {
    title: "(".concat(_this.$t('195d134e'), ")").concat(_this.$t('i18n.f08810fe0bb24376852ccc105c863834')),
    label: _this.$t('i18n.b7332990207a4a289a6be4c00013c631'),
    value: '12,000.00/30* ( 30-12 ) = 7,200.00 THB',
    date: [{
      date: '2022.03',
      day: 31,
      hire: 28,
      leave: '',
      before_min: 16,
      before_max: 27,
      data_min: '',
      data_max: ''
    }, {
      date: '2022.04',
      day: 30,
      hire: '',
      leave: '',
      before_min: '',
      before_max: '',
      data_min: '',
      data_max: ''
    }]
  }],
  // 2
  [{
    title: "(".concat(_this.$t('b195d134'), ")").concat(_this.$t('i18n.afdfff977ffb44d482f0ce31ea2e29f5')),
    label: _this.$t('i18n.b7332990207a4a289a6be4c00013c631'),
    value: '12,000.00/30*21 = 8,400.00 THB',
    date: [{
      date: '2022.03',
      day: 31,
      hire: '',
      leave: '',
      before_min: '',
      before_max: '',
      data_min: 16,
      data_max: 31
    }, {
      date: '2022.04',
      day: 30,
      hire: '',
      leave: 6,
      before_min: '',
      before_max: '',
      data_min: 1,
      data_max: 5
    }]
  }, {
    title: "(".concat(_this.$t('195d134e'), ")").concat(_this.$t('i18n.02e7643f25ea4168baaeadbd84ef7859')),
    label: _this.$t('i18n.b7332990207a4a289a6be4c00013c631'),
    value: '12,000.00/30* ( 30-10 ) = 8,000.00 THB',
    date: [{
      date: '2022.03',
      day: 31,
      hire: '',
      leave: '',
      before_min: '',
      before_max: '',
      data_min: '',
      data_max: ''
    }, {
      date: '2022.04',
      day: 30,
      hire: '',
      leave: 6,
      before_min: 6,
      before_max: 15,
      data_min: '',
      data_max: ''
    }]
  }],
  // 3
  [{
    title: "(".concat(_this.$t('b195d134'), ")").concat(_this.$t('i18n.bff6b33d2c424d03a13ef8d8e2c20888')),
    label: _this.$t('i18n.b7332990207a4a289a6be4c00013c631'),
    value: '12,000.00/30*12 + 15,000.00/30*（ 30-12 ） = 13,800.00 THB',
    date: [{
      date: '2022.03',
      day: 31,
      hire: '',
      leave: '',
      before_min: '',
      before_max: '',
      salary: 28,
      day_min: 16,
      day_max: 27,
      data_min: 16,
      data_max: 31
    }, {
      date: '2022.04',
      day: 30,
      hire: '',
      leave: '',
      before_min: '',
      before_max: '',
      data_min: '1',
      data_max: '15'
    }]
  }, {
    title: "(".concat(_this.$t('195d134e'), ")").concat(_this.$t('i18n.795d499d14e249c9a9d85367e5a38155')),
    label: _this.$t('i18n.b7332990207a4a289a6be4c00013c631'),
    value: '12,000.00/30* ( 30-19 ) + 15,000.00/30*19 = 13,900.00 THB',
    date: [{
      date: '2022.03',
      day: 31,
      hire: '',
      leave: '',
      before_min: '',
      before_max: '',
      salary: 28,
      day_min: 28,
      day_max: 31,
      data_min: 16,
      data_max: 31
    }, {
      date: '2022.04',
      day: 30,
      hire: '',
      leave: '',
      before_min: '',
      before_max: '',
      day_min: 1,
      day_max: 15,
      data_min: 1,
      data_max: 15
    }]
  }],
  // 4
  [{
    title: "(".concat(_this.$t('b195d134'), ")").concat(_this.$t('i18n.68ec1cb8a54c4f74beb1d31502640b8f')),
    label: _this.$t('i18n.b7332990207a4a289a6be4c00013c631'),
    value: '12,000.00/30*（ 12-1 ）+ 15,000.00/30*（ 18-2 ） = 12,400.00 THB',
    date: []
  }, {
    title: "(".concat(_this.$t('195d134e'), ")").concat(_this.$t('i18n.129a912fddf546e99ac0116658e97e1f')),
    label: _this.$t('i18n.b7332990207a4a289a6be4c00013c631'),
    value: '12,000.00/30*（ 12-1-2 ）+ 15,000.00/30*（ 18-0 ）= 12,600.00 THB',
    date: []
  }, {
    title: "(".concat(_this.$t('95d134ea'), ")").concat(_this.$t('i18n.4de9cd599c664be1ace17d94b175c4de')),
    label: _this.$t('i18n.b7332990207a4a289a6be4c00013c631'),
    value: '12,000.00/30*（ 12-0 ）+ 15,000.00/30*（ 18-1-2 ）= 12,300.00 THB',
    date: []
  }],
  // 5
  [{
    title: "(".concat(_this.$t('b195d134'), ")").concat(_this.$t('i18n.68ec1cb8a54c4f74beb1d31502640b8f')),
    label: 'OT',
    value: '12,000.00/30/8*1*1.5 + 15,000.00/30*2*1.5 = 262.50 THB',
    date: []
  }, {
    title: "(".concat(_this.$t('195d134e'), ")").concat(_this.$t('i18n.29c457408a6f4d578f35465e4d9d2c4b')),
    label: 'OT',
    value: '12,000.00/30/8*（ 1+2 ）*1.5 = 225.00 THB',
    date: []
  }, {
    title: "(".concat(_this.$t('95d134ea'), ")").concat(_this.$t('i18n.076082f3ec9f4a55a6ec300bd3670905')),
    label: 'OT',
    value: '15,000.00/30/8*（ 1+2 ）*1.5 = 281.25 THB',
    date: []
  }]];
};
export var exampleTitle = function exampleTitle(_this) {
  return [
  // 1
  {
    title: _this.$t('i18n.6b3472844c91420d9892085f0c11071b'),
    content: [{
      label: _this.$t('i18n.af0899b2737d45718ad65c983efb0b43'),
      value: '2022.03.06-2022.04.05'
    }, {
      label: _this.$t('1516'),
      value: '2022.03.28'
    }, {
      label: _this.$t('payroll_management_34'),
      value: '12,000THB'
    }]
  },
  // 2
  {
    title: _this.$t('i18n.1c06b5f9592c453686a7d0768adaef64'),
    content: [{
      label: _this.$t('i18n.af0899b2737d45718ad65c983efb0b43'),
      value: '2022.03.16-2022.04.15'
    }, {
      label: _this.$t('791'),
      value: '2022.04.06'
    }, {
      label: _this.$t('payroll_management_34'),
      value: '12,000THB'
    }]
  },
  // 3
  {
    title: _this.$t('i18n.447417ca7ba14106acd2124a12d0049c'),
    content: [{
      label: _this.$t('i18n.af0899b2737d45718ad65c983efb0b43'),
      value: '2022.03.16-2022.04.15'
    }, {
      label: _this.$t('i18n.3fcb2d4707434cd98c8afd2336b76005'),
      value: '2022.03.28'
    }, {
      label: _this.$t('i18n.42311b6653c54c2fa09be74bfcf7cf5b'),
      value: '12,000THB'
    }, {
      label: _this.$t('438'),
      value: '15,000THB'
    }]
  },
  // 4
  {
    title: _this.$t('i18n.50879ac886644e56a3546cc0b66c65e5'),
    content: [{
      label: _this.$t('i18n.af0899b2737d45718ad65c983efb0b43'),
      value: '2022.03.16-2022.04.15'
    }, {
      label: _this.$t('i18n.3fcb2d4707434cd98c8afd2336b76005'),
      value: '2022.03.28'
    }, {
      label: _this.$t('i18n.42311b6653c54c2fa09be74bfcf7cf5b'),
      value: '12,000THB'
    }, {
      label: _this.$t('438'),
      value: '15,000THB'
    }, {
      label: _this.$t('706'),
      value: '2022.03.21、2022.04.10、2022.04.11'
    }]
  },
  // 5
  {
    title: _this.$t('i18n.08c4e6f05f9b4437bb13fff3fec917d0'),
    content: [{
      label: _this.$t('i18n.af0899b2737d45718ad65c983efb0b43'),
      value: '2022.03.16-2022.04.15'
    }, {
      label: _this.$t('i18n.3fcb2d4707434cd98c8afd2336b76005'),
      value: '2022.03.28'
    }, {
      label: _this.$t('i18n.42311b6653c54c2fa09be74bfcf7cf5b'),
      value: '12,000THB'
    }, {
      label: _this.$t('438'),
      value: '15,000THB'
    }, {
      label: _this.$t('1711'),
      value: "2022.03.21( 1".concat(_this.$t('waiting_times_label2'), " )\u30012022.04.10( 1").concat(_this.$t('waiting_times_label2'), " )\u30012022.04.11( 1").concat(_this.$t('waiting_times_label2'), " )")
    }],
    tip: _this.$t('i18n.39a4b407728e4341a5ccd4c4edba34cb')
  }];
};